export default function RecorderPointIndicator() {
  return (
    <>
      <div className="absolute left-1/2 -translate-x-1/2 w-0.5 h-[80%] bg-red-500 rounded-full" />
      <div className="absolute left-1/2 top-[10%] -translate-x-1/2 w-[10px] h-[10px] bg-red-500 rounded-full" />
      <div className="absolute left-1/2 bottom-[10%] -translate-x-1/2 w-[10px] h-[10px] bg-red-500 rounded-full" />
    </>
  );
}
